<app-header [enableBack]="false">
  <div title>
    {{ 'connectionpoint.title' | translate }}
  </div>
</app-header>

<div class="p-6">
  <form [formGroup]="queryForm">
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'connectionpoint.connectionPointId' | translate }}</label>
            <input type="text" appInput autofocus formControlName="meteringPointIdentification"
                   [placeholder]="'connectionpoint.connectionPointId' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'connectionpoint.identification' | translate }}</label>
            <input
              type="text"
              appInput
              formControlName="connectionPointIdentification"
              [placeholder]="'connectionpoint.identification' | translate"
            >
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'connectionpoint.alternativeIdentification' | translate }}</label>
            <input
              type="text"
              appInput
              formControlName="alternativeConnectionPointIdentification"
              [placeholder]="'connectionpoint.alternativeIdentification' | translate"
            >
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
            <input type="text" appInput formControlName="meterNumber" [placeholder]="'meter.meterNumber' | translate">
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'connectionpoint.stationsNumber' | translate }}</label>
            <input type="text" appInput formControlName="stationNumber"
                   [placeholder]="'connectionpoint.stationsNumber' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.streetName' | translate }}</label>
            <input
              type="text"
              appInput
              formControlName="streetName"
              [placeholder]="'address.streetName' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.streetNumber' | translate }}</label>
            <input type="text" appInput formControlName="streetNumber"
                   [placeholder]="'address.streetNumber' | translate">
          </app-input-group>
        </div>
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.floor' | translate }}</label>
            <input type="text" appInput formControlName="floorIdentification"
                   [placeholder]="'address.floor' | translate">
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'address.zipCode' | translate }}</label>
            <input appInput inputmode="numeric" pattern="[0-9]*" formControlName="postalCode" [placeholder]="'address.zipCode' | translate">
          </app-input-group>
        </div>
      </div>
      <div class="flex gap-2">
        <button appButton (click)="performSearch()">{{ 'common.search' | translate }}</button>
        <button appButton type="tertiary" (click)="reset()">{{ 'common.reset' | translate }}</button>
      </div>
    </app-card>
  </form>


  <app-table
    #table
    [config]="connectionPointTableConfig"
    [(selectedElements)]="selectedElements">
  </app-table>
</div>
